import {isStandalone} from './env';

export interface AccountPlan {
  name: string;
  cap: number;
  id: number;
  is_free: boolean;
  price: number;
  term_length_in_months: number;
  tier: string;
}

/**
 * These corresponds to templates/reports/base-new.html
 * Over time we want to reduce this list and use apis instead.
 * If you remove a global here, remove it from base-new as well for iron apps
 */
export interface MpReportGlobals {
  blocking: {is_blocked_events: boolean; is_blocked_people: boolean; label: string};
  /**
   * Passed as a GET param
   * from the report being downloaded
   * to the webapp
   * then re-injected back into the html template.
   *
   * To find the true type, check the `display_preference` set by your app.
   */
  feature_gate_name: string;
  feature_gates: Obj;
  flags: Obj;
  is_project_member: boolean;
  organization_id: string;
  permissions: string[];
  project_featureflags: string[];
  project_id: string;
  project_timezone: number;
  project_type: number;
  timezones: Array<[number, string, number]>;
  user_email: string;
  user_feature_flags: string[];
  user_id: string;
  user_name: string;
  utc_offset: number;
  workspace_id: number;
}

/**
 * returns mp.report.globals as a typed object.
 */
export function getMpReportGlobals(): MpReportGlobals {
  if (isStandalone()) {
    throw new Error(`mp.report.globals aren't available in standalone mode, use stores instead`);
  }

  // eslint-disable-next-line local-rules/deprecated-member-access
  return mp.report.globals;
}
